import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { UnsavedChangesModalService } from '../can-deactivate-guard/unsaved-changes-modal.service';

@Component({
  selector: 'app-unsaved-changes-modal-wrapper',
  templateUrl: './unsaved-changes-modal-wrapper.component.html',
  styleUrls: ['./unsaved-changes-modal-wrapper.component.scss']
})

export class UnsavedChangesModalWrapperComponent implements OnInit, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();

  showModal: boolean = false;

  constructor(private unsavedChangesModalService: UnsavedChangesModalService) {}


  ngOnInit() {
      this.unsavedChangesModalService.showModalEmitter
      .pipe(takeUntil(this._destroyStream))
      .subscribe((value) => {
        this.showModal = value; // This will show the modal
      });

      // Existing subscription to handle the resolution of the dialog
      this.unsavedChangesModalService.showConfirmDialog()
      .pipe(takeUntil(this._destroyStream))
      .subscribe((value) => this.showModal = value);

  }

  closeModal(confirmation: boolean) {
    this.unsavedChangesModalService.resolveDialog(confirmation);
    this.showModal = false;
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }
}
